import classNames from "classnames";
import Header from "../header/Header";
import FunnelStepHeader from "../../components/step/funnel-step/header/FunnelStepHeader";
import styles from "./Content.module.scss";
import { PropsWithChildren, useRef } from "react";
import { Box } from "@chakra-ui/react";
import { AlertContext } from "components/alerts/AlertContext";

const Content = ({ children, isScanner }: { isScanner: boolean } & PropsWithChildren) => {
  const alertRef = useRef(null);

  return (
    <Box
      ml="12%"
      flex="1 0 auto"
      sx={
        isScanner
          ? {
              "@media(width<=1280px)": {
                width: "100%",
                height: "100%",
                margin: 0,
                padding: 0,
              },
            }
          : {
              "@media(width<=1280px)": {
                margin: "auto",
              },
              "@media(width<=480px)": {
                width: "100%",
              },
            }
      }
    >
      {!isScanner && (
        <>
          <Header />
          <FunnelStepHeader className={styles.header} />

          <Box ref={alertRef}></Box>
        </>
      )}
      <AlertContext.Provider value={{ ref: alertRef }}>
        <div
          className={classNames(styles.contentWrapper, isScanner && styles.scannerContentWrapper)}
        >
          {children}
        </div>
      </AlertContext.Provider>
    </Box>
  );
};

export default Content;
